<template>
  <div class="user">
    <!--div class="photo"-->
      <!--v-gravatar v-if="!!user.email" :email="user.email" :size="34" /-->
      <!--img src="static/img/faces/face-2.jpg"/-->
    <!--/div-->
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             {{ this.user.email }}
          </span>
      </a>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import store from '@/store'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        isClosed: true,
        user: {}
      }
    },
    methods: {
      toggleMenu () {
        // this.isClosed = !this.isClosed
        this.$router.replace('/admin/profile')
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        this.user = store.getUser()
      })
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue